import React from 'react';

import { StickyTabNavigation } from 'src/components/sticky-tab-nav';

import { UseNavigationTabs } from './utils';

import { TabAnchor, TabCounts } from './types';

// Includes at least the 'All' tab and two more tabs
const MIN_TABS_VISIBLE = 3;

type Props = {
  activeTab: string;
  onClick: (tab: string) => void;
  testsAndGuidesCount: number;
} & TabCounts;

export const SearchResultsNavigation = (props: Props) => {
  const {
    activeTab,
    brandsCount,
    categoriesCount,
    productsCount,
    storesCount,
    testsAndGuidesCount,
    onClick,
  } = props;

  const navigationTabs = UseNavigationTabs({
    brandsCount,
    categoriesCount,
    productsCount,
    storesCount,
    testsAndGuidesCount,
  });

  if (navigationTabs.length < MIN_TABS_VISIBLE) return null;

  return (
    <StickyTabNavigation
      defaultActiveTabId={activeTab || TabAnchor.ALL}
      tabs={navigationTabs}
      onClick={onClick}
      shouldScrollOnClick={false}
    />
  );
};
